(function ready() {
  // anchor links for scrolling to id
  const anchors = [].slice.call(document.querySelectorAll('a[href^="#"]:not([data-borlabs-cookie-unblock])'));
  anchors.forEach((anchor) => {
    anchor.addEventListener('click', anchorScrollTo);
  });


  // reveal initial hidden
  const revealTrigger = [].slice.call(document.querySelectorAll('.js-reveal-initial-hidden'));
  revealTrigger.forEach((trigger) => {
    trigger.addEventListener('click', revealInitialHidden);
  });


  // send gtag data-event
  const eventTrigger = [].slice.call(document.querySelectorAll('[data-event]'));
  eventTrigger.forEach((trigger) => {
    trigger.addEventListener('click', (tar) => {
      gtagSendEvent('mc_data_event', {
        category: tar.currentTarget.dataset.event.match(/(?:category): ([^,]{2,})(?:,? ?)/i)[1],
        action: tar.currentTarget.dataset.event.match(/(?:action): ([^,]{2,})(?:,? ?)/i)[1],
        label: tar.currentTarget.dataset.event.match(/(?:label): ([^,]{1,})(?:,? ?)/i)[1],
      });
    });
  });


  // send nav menu events
  const mainNavTrigger = [].slice.call(document.querySelectorAll('.main-navigation a'));
  mainNavTrigger.forEach((trigger) => {
    trigger.addEventListener('click', (tar) => {
      gtagSendEvent('mc_data_event', {
        category: 'Main Navigation',
        action: 'Link',
        label: tar.currentTarget.href
      });
    });
  });

  const footerNavTrigger = [].slice.call(document.querySelectorAll('.footer-menu-navigation a'));
  footerNavTrigger.forEach((trigger) => {
    trigger.addEventListener('click', (tar) => {
      gtagSendEvent('mc_data_event', {
        category: 'Footer Navigation',
        action: 'Link',
        label: tar.currentTarget.href
      });
    });
  });

  const legalNavTrigger = [].slice.call(document.querySelectorAll('.legal-navigation a'));
  legalNavTrigger.forEach((trigger) => {
    trigger.addEventListener('click', (tar) => {
      gtagSendEvent('mc_data_event', {
        category: 'Legal Navigation',
        action: 'Link',
        label: tar.currentTarget.href
      });
    });
  });


  // new window links
  const newWindowAnchor = [].slice.call(document.querySelectorAll('.js-new-window'));
  newWindowAnchor.forEach((trigger) => {
    trigger.addEventListener('click', (tar) => {
      tar.preventDefault();
      window.open(tar.currentTarget.href, 'Share', 'resizable, height=700, width=500');
    });
  });


  const blogTextAreaLinks = [].slice.call(document.querySelectorAll('.text-area.-blog a:not(.link):not(.button)'));
  blogTextAreaLinks.forEach((trigger) => {
    trigger.addEventListener('click', (tar) => {
      gtagSendEvent('mc_data_event', {
        category: 'Text Area (Blog)',
        action: 'Link',
        label: tar.currentTarget.href,
      });
    });
  })


  document.body.addEventListener('click', (event) => {
    // Ninja Form Submit Events
    if (event.target.classList.contains('ninja-forms-field') && event.target.tagName === 'INPUT' && event.target.type === 'submit') {
      const targets = document.querySelectorAll('.nf-response-msg');
      const formWrapper = document.querySelector('[data-form-id]');
      const observer = new MutationObserver(((mutations) => {
        mutations.forEach((mutationRecord) => {
          gtagSendEvent('mc_data_event', {
            category: 'form-submission',
            action: 'submit',
            label: `form-id-${formWrapper.dataset.formId}`,
          });
        });
      }));

      Array.from(targets).forEach((target) => {
        observer.observe(target, {
          attributes: true,
          attributeFilter: ['style'],
        });
      });
    }
  });
}());
